(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrossel-materiais"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('materials-carousel')) {
    customElements.define('materials-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.cards = Array.from(this.querySelectorAll('.mc__card'));
        if (!this.cards.length) return;
        this.active = 0;
        this.setAttribute('data-ready', '');
        const controls = this.querySelector('.mc__controls');
        if (controls) controls.hidden = false;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.step)), options));
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.cards.forEach((card, index) => card.addEventListener('click', event => {
          if (index === this.active) return;
          event.preventDefault();
          this.active = index;
          this.update();
        }, options));
        const stage = this.querySelector('.mc__stage');
        this.stage = stage;
        this.gesture = null;
        this.suppressClickUntil = 0;
        stage.addEventListener('dragstart', event => event.preventDefault(), options);
        stage.addEventListener('click', event => {
          if (Date.now() >= this.suppressClickUntil || event.detail === 0) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, { ...options, capture: true });
        // Touch events keep Safari swipes separate from compatibility pointer events.
        stage.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) { this.finishDrag(true); return; }
          const touch = event.touches[0];
          this.startDrag('touch', touch.identifier, touch.clientX, touch.clientY);
        }, { ...options, passive: true });
        stage.addEventListener('touchmove', event => {
          if (event.touches.length !== 1) { this.finishDrag(true); return; }
          const gesture = this.gesture;
          if (!gesture || gesture.kind !== 'touch') return;
          const touch = Array.from(event.touches).find(item => item.identifier === gesture.id);
          if (touch) this.dragTo(touch.clientX, touch.clientY, event);
        }, { ...options, passive: false });
        stage.addEventListener('touchend', event => {
          const gesture = this.gesture;
          if (!gesture || gesture.kind !== 'touch') return;
          const touch = Array.from(event.changedTouches).find(item => item.identifier === gesture.id);
          if (!touch) return;
          this.dragTo(touch.clientX, touch.clientY);
          this.finishDrag(false);
        }, options);
        stage.addEventListener('touchcancel', () => this.finishDrag(true), options);
        stage.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch' || !event.isPrimary || event.button !== 0) return;
          this.startDrag('pointer', event.pointerId, event.clientX, event.clientY);
        }, options);
        window.addEventListener('pointermove', event => {
          const gesture = this.gesture;
          if (!gesture || gesture.kind !== 'pointer' || event.pointerId !== gesture.id) return;
          this.dragTo(event.clientX, event.clientY, event);
        }, { ...options, passive: false });
        window.addEventListener('pointerup', event => {
          const gesture = this.gesture;
          if (!gesture || gesture.kind !== 'pointer' || event.pointerId !== gesture.id) return;
          this.dragTo(event.clientX, event.clientY);
          this.finishDrag(false);
        }, options);
        window.addEventListener('pointercancel', event => {
          if (this.gesture?.kind === 'pointer' && event.pointerId === this.gesture.id) this.finishDrag(true);
        }, options);
        window.addEventListener('blur', () => this.finishDrag(true), options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.mc__card');
          if (!card) return;
          this.active = this.cards.indexOf(card);
          this.update();
        }, options);
        this.update(false);
      }
      disconnectedCallback() {
        this.finishDrag(true);
        this.abort?.abort();
      }
      startDrag(kind, id, x, y) {
        if (this.cards.length < 2) return;
        this.finishDrag(true);
        this.suppressClickUntil = 0;
        this.gesture = { kind, id, x, y, dx: 0, axis: null };
      }
      dragTo(x, y, event) {
        const gesture = this.gesture;
        if (!gesture) return;
        const dx = x - gesture.x;
        const dy = y - gesture.y;
        if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 8) {
          gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (gesture.axis === 'x') this.stage.setAttribute('data-dragging', '');
        }
        if (gesture.axis !== 'x') return;
        if (event?.cancelable) event.preventDefault();
        gesture.dx = dx;
        const offset = Math.max(-this.stage.clientWidth * .4, Math.min(this.stage.clientWidth * .4, dx));
        this.cards.forEach(card => { card.style.translate = offset + 'px 0'; });
      }
      finishDrag(cancelled) {
        const gesture = this.gesture;
        if (!gesture) return;
        this.gesture = null;
        // Commit the finger position before animating to the next card.
        if (gesture.axis === 'x') void this.stage.offsetWidth;
        this.stage.removeAttribute('data-dragging');
        this.cards.forEach(card => { card.style.translate = ''; });
        if (gesture.axis !== 'x') return;
        this.suppressClickUntil = Date.now() + 500;
        const threshold = Math.min(70, Math.max(30, this.cards[0].offsetWidth * .1));
        if (!cancelled && Math.abs(gesture.dx) >= threshold) this.move(gesture.dx < 0 ? 1 : -1);
      }
      move(step) {
        this.active = (this.active + step + this.cards.length) % this.cards.length;
        this.update();
      }
      update(announce = true) {
        const count = this.cards.length;
        this.cards.forEach((card, index) => {
          const distance = (index - this.active + count) % count;
          card.dataset.position = distance === 0 ? '0' : distance === 1 ? '1' : distance === count - 1 ? '-1' : 'hidden';
          card.setAttribute('aria-hidden', String(distance !== 0));
          card.querySelectorAll('a').forEach(link => link.tabIndex = distance === 0 ? 0 : -1);
        });
        if (announce) this.querySelector('.mc__status').textContent = `${this.active + 1} / ${count}: ${this.cards[this.active].querySelector('.mc__label').textContent.trim()}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-por-produto"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('flora-product-rows')){
const mountRows=()=>document.querySelectorAll('flora-product-rows').forEach(node=>{
const source=document.getElementById(node.dataset.source);
const info=document.querySelector('flora-product .fp__info');
if(source&&info&&node.parentElement!==info)info.append(node);
});
customElements.define('flora-product-rows',class extends HTMLElement{
connectedCallback(){queueMicrotask(mountRows);}
});
document.addEventListener('DOMContentLoaded',mountRows);
document.addEventListener('shopify:section:load',mountRows);
document.addEventListener('shopify:section:unload',event=>{
document.querySelectorAll('flora-product-rows').forEach(node=>{
const source=document.getElementById(node.dataset.source);
if(!source)return;
if(event.target===source){if(!source.contains(node))node.remove();}
else if(event.target.contains(node))source.append(node);
});
});
mountRows();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flora-benefits-accordion"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('flora-benefits')){
  customElements.define('flora-benefits',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();
      this.controller=new AbortController();
      this.addEventListener('shopify:block:select',event=>{
        const item=event.target.closest('details');
        if(item&&this.contains(item))item.open=true;
      },{signal:this.controller.signal});
    }
    disconnectedCallback(){this.controller?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flora-customer-stories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('flora-stories')){
  customElements.define('flora-stories',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.track=this.querySelector('.fcs__track');
      this.progress=this.querySelector('.fcs__progress span');
      const buttons=[...this.querySelectorAll('[data-direction]')];
      this.update=()=>{
        const {scrollWidth,clientWidth,scrollLeft}=this.track;
        const max=Math.max(0,scrollWidth-clientWidth);
        this.progress.style.transform='scaleX('+Math.min(1,(clientWidth+scrollLeft)/Math.max(1,scrollWidth))+')';
        buttons[0].disabled=scrollLeft<2;
        buttons[1].disabled=scrollLeft>=max-2;
      };
      buttons.forEach(b=>b.addEventListener('click',()=>{
        const card=this.track.querySelector('.fcs__photo,.fcs__card');
        const step=(card?.getBoundingClientRect().width||260)+parseFloat(getComputedStyle(this.track).gap||0);
        this.track.scrollBy({left:step*Number(b.dataset.direction),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      },options));
      this.track.addEventListener('keydown',e=>{
        if(e.target!==this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
        e.preventDefault();
        if(e.key==='Home'||e.key==='End'){
          this.track.scrollTo({left:e.key==='Home'?0:this.track.scrollWidth,behavior:'instant'});
        }else{
          buttons[e.key==='ArrowLeft'?0:1].click();
        }
      },options);
      this.track.addEventListener('scroll',this.update,{passive:true,...options});
      this.observer=new ResizeObserver(this.update);
      this.observer.observe(this.track);
      document.addEventListener('shopify:block:select',e=>{
        if(this.contains(e.target))e.target.querySelector('.fcs__photo,.fcs__card')?.scrollIntoView({block:'nearest',inline:'start',behavior:'instant'});
      },options);
      this.update();
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flora-product-gifts"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('flora-product-gifts')){
const mountGifts=()=>document.querySelectorAll('flora-product-gifts').forEach(node=>{
const info=document.querySelector('flora-product .fp__info');
if(!document.getElementById(node.dataset.source)||!info)return;
const buy=info.querySelector('.fp__block--buy_buttons');
if(buy){if(node.nextElementSibling!==buy)buy.parentElement.insertBefore(node,buy);return;}
const rows=info.querySelector('flora-product-rows');
if(rows){if(node.nextElementSibling!==rows)info.insertBefore(node,rows);}
else if(node.parentElement!==info)info.append(node);
});
customElements.define('flora-product-gifts',class extends HTMLElement{connectedCallback(){queueMicrotask(mountGifts);}});
document.addEventListener('DOMContentLoaded',mountGifts);
document.addEventListener('shopify:section:load',mountGifts);
document.addEventListener('shopify:section:unload',event=>document.querySelectorAll('flora-product-gifts').forEach(node=>{
const source=document.getElementById(node.dataset.source);
if(!source)return;
if(event.target===source){if(!source.contains(node))node.remove();}
else if(event.target.contains(node))source.append(node);
}));
mountGifts();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flora-reviews-loop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('flora-review-loop')){
customElements.define('flora-review-loop',class extends HTMLElement{
connectedCallback(){
 if(this.controller)return;
 this.controller=new AbortController();const signal=this.controller.signal;
 this.view=this.querySelector('.frl__viewport');this.track=this.querySelector('.frl__track');this.group=this.querySelector('.frl__group');
 if(!this.group?.children.length)return;
 this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.reduced.matches;this.hover=false;this.focused=false;this.dragging=false;this.visible=false;
 this.auto=this.dataset.auto==='true'&&this.group.children.length>1;
 const on=(el,event,fn)=>el?.addEventListener(event,fn,{signal});
 this.resize=()=>{this.track.querySelectorAll('[data-copy]').forEach(n=>n.remove());this.distance=this.group.getBoundingClientRect().width+16;if(this.auto&&this.distance>0){const copies=Math.max(1,Math.ceil(this.view.clientWidth/this.distance));for(let i=0;i<copies;i++){const clone=this.group.cloneNode(true);clone.dataset.copy='';clone.setAttribute('aria-hidden','true');clone.querySelectorAll('[data-shopify-editor-block]').forEach(n=>n.removeAttribute('data-shopify-editor-block'));this.track.append(clone);}}this.position=this.view.scrollLeft;};
 this.resize();this.observer=new ResizeObserver(this.resize);this.observer.observe(this.view);
 this.intersection=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.last=0;});this.intersection.observe(this);
 on(this.view,'pointerenter',e=>{if(e.pointerType==='mouse')this.hover=true;});on(this.view,'pointerleave',()=>this.hover=false);
 on(this.view,'pointerdown',()=>this.dragging=true);on(window,'pointerup',()=>{this.dragging=false;this.last=0;});on(window,'pointercancel',()=>this.dragging=false);
 on(this.view,'focusin',()=>this.focused=true);on(this.view,'focusout',()=>this.focused=false);
 on(this.view,'scroll',()=>{if(Math.abs(this.view.scrollLeft-this.position)>2)this.position=this.view.scrollLeft;if(this.auto&&this.distance&&this.position>=this.distance){this.position%=this.distance;this.view.scrollLeft=this.position;}});
 const sync=()=>{const b=this.querySelector('[data-pause]');if(!b)return;b.setAttribute('aria-pressed',String(this.paused));b.querySelector('[data-pause-label]').hidden=this.paused;b.querySelector('[data-resume-label]').hidden=!this.paused;};
 on(this.querySelector('[data-prev]'),'click',()=>{this.paused=true;sync();const step=this.group.children[0].getBoundingClientRect().width+16;let x=this.view.scrollLeft-step;if(this.auto&&x<0)x+=this.distance;this.view.scrollLeft=Math.max(0,x);});
 on(this.querySelector('[data-next]'),'click',()=>{this.paused=true;sync();const step=this.group.children[0].getBoundingClientRect().width+16;this.view.scrollLeft+=step;});
 const pause=this.querySelector('[data-pause]');if(pause)on(pause,'click',()=>{this.paused=!this.paused;this.last=0;sync();});
 on(this.reduced,'change',e=>{this.paused=e.matches;sync();});
 on(this,'shopify:block:select',e=>{this.paused=true;sync();const card=e.target.closest('.frl__card');if(card)this.view.scrollLeft=card.offsetLeft-this.group.offsetLeft;});
 sync();
 const tick=time=>{const dt=this.last?Math.min(time-this.last,50):0;this.last=time;if(this.auto&&this.visible&&!document.hidden&&!this.paused&&!this.hover&&!this.focused&&!this.dragging){this.position=(this.position+dt*Number(this.dataset.speed)/1000)%this.distance;this.view.scrollLeft=this.position;}this.frame=requestAnimationFrame(tick);};this.frame=requestAnimationFrame(tick);
}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort();this.observer?.disconnect();this.intersection?.disconnect();this.track?.querySelectorAll('[data-copy]').forEach(n=>n.remove());this.controller=null;}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flora-shipping-payments"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('flora-shipping-payments')){
let countryRequest;
const detectCountry=()=>{
if(!countryRequest)countryRequest=(async()=>{
const controller=new AbortController();
const timer=setTimeout(()=>controller.abort(),4000);
try{
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'browsing_context_suggestions.json?country[enabled]=true',{signal:controller.signal,credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
if(!response.ok)return null;
const data=await response.json();
const country=data.detected_values?.country;
return typeof country?.name==='string'&&country.name.trim()?country.name:null;
}catch{return null;}finally{clearTimeout(timer);}
})();
return countryRequest;
};
const mount=()=>document.querySelectorAll('flora-shipping-payments').forEach(node=>{
if(!document.getElementById(node.dataset.source))return;
const buy=document.querySelector('flora-product .fp__block--buy_buttons');
if(buy&&buy.nextElementSibling!==node)buy.after(node);
const label=node.querySelector('[data-fsp-country]');
if(label)detectCountry().then(name=>{if(name&&label.isConnected)label.textContent=name;});
});
customElements.define('flora-shipping-payments',class extends HTMLElement{connectedCallback(){queueMicrotask(mount);}});
document.addEventListener('DOMContentLoaded',mount);
document.addEventListener('shopify:section:load',mount);
document.addEventListener('shopify:section:unload',event=>document.querySelectorAll('flora-shipping-payments').forEach(node=>{
const source=document.getElementById(node.dataset.source);
if(!source)return;
if(event.target===source){if(!source.contains(node))node.remove();}
else if(event.target.contains(node))source.append(node);
}));
mount();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-por-produto"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('flora-product-videos')) {
  customElements.define('flora-product-videos', class extends HTMLElement {
    connectedCallback() {
      this.warmObserver?.disconnect();
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.fpv__player');
      this.items = Array.from(this.querySelectorAll('.fpv__item'));
      this.sound = this.dialog.querySelector('[data-sound]');
      this.toggle = this.dialog.querySelector('[data-toggle]');
      this.forceMuted = this.dataset.muted === 'true';
      this.expand = this.dataset.expand !== 'false';
      this.muted = this.forceMuted;
      this.pending = new Map();
      this.sound.hidden = this.forceMuted;
      this.sound.setAttribute('aria-pressed', String(!this.muted));
      this.sound.addEventListener('click', () => {
        this.muted = !this.muted;
        const video = this.player.querySelector('video');
        if (video) video.muted = this.muted;
        this.sound.setAttribute('aria-pressed', String(!this.muted));
      }, options);
      this.toggle.addEventListener('click', () => {
        const video = this.player.querySelector('video');
        if (!video) return;
        if (video.paused) this.playVideo(video,this.player,this.querySelector('.fpv__error'));
        else video.pause();
      }, options);
      this.player.addEventListener('touchstart', event => {
        this.touch = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
      }, {...options, passive:true});
      this.player.addEventListener('touchend', event => {
        if (!this.touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && this.items.length > 1) this.show(this.index + (dx < 0 ? 1 : -1));
      }, {...options, passive:true});
      this.player.addEventListener('touchcancel', () => { this.touch = null; }, options);
      this.querySelectorAll('[data-open]').forEach((button, index) => {
        button.addEventListener('click', () => {
          this.opener = button;
          if (!this.expand) { this.showInline(index); return; }
          this.dialog.showModal();
          this.show(index);
        }, options);
      });
      this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.show(this.index + Number(button.dataset.step)), options));
      this.dialog.addEventListener('close', () => { this.stop(); this.opener?.focus({preventScroll:true}); }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      if (!this.expand && 'IntersectionObserver' in window) {
        this.warmObserver=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{if(entry.isIntersecting){this.showInline(this.items.indexOf(entry.target),true);this.warmObserver.unobserve(entry.target);}});
        },{rootMargin:'200px'});
        this.items.forEach(item=>this.warmObserver.observe(item));
      }
      this.dialog.addEventListener('keydown', event => {
        
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
    }
    watchVideo(video, host, error) {
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.controls = false;
      const cover = document.createElement('img');
      cover.className = 'fpv__loading-cover';
      cover.alt = '';
      if (video.poster) { cover.src = video.poster; host.append(cover); }
      const options = {signal:this.abort.signal};
      const ready = () => {
        if (video.paused || video.readyState < 2) return;
        cover.hidden = true;
        host.removeAttribute('aria-busy');
        clearTimeout(this.pending.get(video));
        this.pending.delete(video);
        error.hidden = true;
      };
      video.addEventListener('playing', () => {
        if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(ready);
        else ready();
      }, options);
      video.addEventListener('timeupdate', ready, options);
      video.addEventListener('waiting', () => host.setAttribute('aria-busy','true'), options);
      video.addEventListener('error', () => this.failedVideo(video, host, error), options);
      video.addEventListener('pause', () => {host.removeAttribute('aria-busy');clearTimeout(this.pending.get(video));this.pending.delete(video);}, options);
      video.addEventListener('play', () => {
        this.querySelectorAll('video').forEach(other => {if(other!==video)other.pause();});
      }, options);
    }
    failedVideo(video, host, error) {
      clearTimeout(this.pending.get(video));this.pending.delete(video);
      video.pause();host.removeAttribute('aria-busy');error.hidden=false;
      const cover=host.querySelector('.fpv__loading-cover');if(cover)cover.hidden=false;
    }
    playVideo(video, host, error) {
      error.hidden=true;host.setAttribute('aria-busy','true');
      if(video.error)video.load();
      clearTimeout(this.pending.get(video));
      this.pending.set(video,setTimeout(()=>this.failedVideo(video,host,error),15000));
      const result=video.play();
      if(result)result.catch(e=>{if(e.name!=='AbortError')this.failedVideo(video,host,error);});
    }
    configureAudio(video) {
      video.defaultMuted = this.forceMuted;
      video.muted = this.muted;
      if (this.forceMuted) video.addEventListener('volumechange', () => {
        if (!video.muted) video.muted = true;
      }, {signal:this.abort.signal});
    }
    showInline(index, prepare = false) {
      const item = this.items[index];
      const host = item.querySelector('.fpv__inline');
      let video = host.querySelector('video');
      if (!video) {
        host.append(item.querySelector('template').content.cloneNode(true));
        video = host.querySelector('video');
        video.controls = false;
        video.playsInline = true;
        video.setAttribute('controlslist', 'nofullscreen noremoteplayback');
        video.disablePictureInPicture = true;
        video.disableRemotePlayback = true;
        this.configureAudio(video);
        this.watchVideo(video,host,item.querySelector('.fpv__inline-error'));
        const options = {signal:this.abort.signal};
        const toggle = this.toggle.cloneNode(true);
        toggle.replaceChildren(item.querySelector('.fpv__play .fpv__icon').cloneNode(true));
        host.append(toggle);
        const update = () => {
          toggle.dataset.paused = String(video.paused);
          host.dataset.playing = String(!video.paused);
          toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        };
        const play = () => {
          item.querySelector('.fpv__inline-error').hidden = true;
          this.playVideo(video,host,item.querySelector('.fpv__inline-error'));
        };
        toggle.addEventListener('click', () => { if (video.paused) play(); else video.pause(); }, options);
        video.addEventListener('click', () => { if (video.paused) play(); else video.pause(); }, options);
        ['play','pause','ended','volumechange'].forEach(name => video.addEventListener(name, update, options));
        update();
        video.addEventListener('play', () => {
          this.querySelectorAll('.fpv__inline video').forEach(other => { if (other !== video) other.pause(); });
        }, {signal:this.abort.signal});
        video.addEventListener('error', () => { item.querySelector('.fpv__inline-error').hidden = false; }, {signal:this.abort.signal});
      }
      if (prepare) { video.preload='metadata'; return; }
      host.hidden = false;
      item.querySelector('[data-open]').hidden = true;
      item.querySelector('.fpv__inline-error').hidden = true;
      host.querySelector('[data-toggle]').focus({preventScroll:true});
      this.playVideo(video,host,item.querySelector('.fpv__inline-error'));
    }
    updateToggle(video) {
      this.toggle.setAttribute('aria-label', video.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      this.toggle.dataset.paused = String(video.paused);
    }
    stop() {
      const video = this.player?.querySelector('video');
      if (video) { clearTimeout(this.pending?.get(video)); this.pending?.delete(video); video.pause(); video.removeAttribute('src'); video.querySelectorAll('source').forEach(source => source.remove()); video.load(); }
      this.player?.replaceChildren();
    }
    show(index) {
      this.stop();
      this.index = (index + this.items.length) % this.items.length;
      this.player.append(this.items[this.index].querySelector('template').content.cloneNode(true));
      const video = this.player.querySelector('video');
      this.configureAudio(video);
      this.watchVideo(video,this.player,this.querySelector('.fpv__error'));
      this.querySelector('.fpv__error').hidden = true;
      const options = {signal:this.abort.signal};
      ['play','pause','ended'].forEach(name => video.addEventListener(name, () => this.updateToggle(video), options));
      video.addEventListener('error', () => { this.querySelector('.fpv__error').hidden = false; }, options);
      this.updateToggle(video);
      this.playVideo(video,this.player,this.querySelector('.fpv__error'));
    }
    disconnectedCallback() { this.warmObserver?.disconnect();this.pending?.forEach(timer=>clearTimeout(timer)); this.querySelectorAll('.fpv__inline video').forEach(video => video.pause()); this.abort?.abort(); this.stop(); if (this.dialog?.open) this.dialog.close(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
